const brainFunnelCampaigns = ["1", "2", "4", "15", "18", "22", "24", "29"];

export const isBrainFunnelCampaign = (campaign_id) => {
  if (brainFunnelCampaigns.includes(campaign_id)) {
    return true;
  }
};
